import { makeStyles, shorthands } from '@fluentui/react-components';

export const useOverviewPageStyles = makeStyles({
  pageContainer: {
    maxWidth: '2200px',
    minWidth: '200px',
    position: 'relative',
    ...shorthands.padding('16px', '26px', '8px'),
  },
  cardsContainer: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      clear: 'both',
    },
  },
  disclaimer: {
    ...shorthands.margin('12px', '0px', '0px', '0px'),
    '& .disclaimer-banner': {
      ...shorthands.padding('0px', '0px', '0px', '8px'),
    },
  },
  cardWidth33: {
    width: '33.3%',
  },
  cardWidth50: {
    width: '50%',
  },
  cardWidth66: {
    width: '66.6%',
  },
  cardWidth100: {
    width: '100%',
  },
  cardBasic: {
    height: '389px',
    minWidth: '320px',
  },
  dynamicHeight: {
    minWidth: '320px',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: '20px',
  },
  errorImage: {
    width: '150px',
    height: '150px',
    marginBottom: '10px',
  },
  errorMessage: {
    width: '450px',
    textAlign: 'center',
    margin: '0 auto',
  },
});
